import { SharedModule } from 'src/app/components/shared';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { Component, inject, input, signal } from "@angular/core";
import { PopoverController } from "@ionic/angular";
import { User } from "src/app/interfaces/user";
import { UtilsService } from "src/app/services/utils/utils.service";

@Component({
    selector: "app-user",
    templateUrl: "./user.component.html",
    styleUrls: ["./user.component.scss"],
    standalone: true,
    imports: [CommonModule, IonicModule, RouterModule, SharedModule]
})
export class UserComponent {
  private popover = inject(PopoverController);
  private utils = inject(UtilsService);

  readonly user = input<User>(undefined);

  readonly link = input<boolean>(true);

  readonly statitics = input<boolean>(true);

  /** Era un campo asignado en ngOnInit; no depende de nada que cambie después. */
  readonly isMobileBrowser = this.utils.isMobileBrowser();

  /** Se abre y se cierra tras un await: sin señal, con OnPush la clase no se quitaría. */
  readonly userStatiticsIsOpen = signal(false);

  private idTimeout: any = 0;

  mouseenter(event: Event) {
    clearTimeout(this.idTimeout);
    this.idTimeout = setTimeout(() => this.openUserStats(event), 250);
  }

  mouseleave() {
    clearTimeout(this.idTimeout);
  }

  async openUserStats(event: Event) {
    this.userStatiticsIsOpen.set(true);

    // Se carga al abrir, no al arrancar: <app-user> va en el cascarón eager y arrastraba
    // las estadísticas (20 KB) a main.js para todo el mundo (lote 21).
    const { UserStatisticsComponent } = await import('../user-statistics/user-statistics.component');
    const popover = await this.popover.create({
      component: UserStatisticsComponent,
      cssClass: 'UserStatisticsComponent',
      event,
      showBackdrop: this.isMobileBrowser,
      alignment: 'start',
      side: this.isMobileBrowser ? 'bottom' : 'top',
      componentProps: {
        userId: this.user()?.id
      }
    });

    await popover.present();
    await popover.onDidDismiss();

    this.userStatiticsIsOpen.set(false);
  }
}
